import React, { useState, useEffect } from 'react';
import { Card, Typography, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { colors } from '../components/Theme/WebTheme';
import { FONT_FAMILY } from '../common/sharedFunctions';
import { useTranslation } from 'react-i18next';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

export default function FleetAdminWalletBalance() {
  const { t } = useTranslation();
  const [totalBalance, setTotalBalance] = useState(0);
  const [fleetAdminCount, setFleetAdminCount] = useState(0);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const settings = useSelector(state => state.settingsdata.settings);

  useEffect(() => {
    if (staticusers && settings) {
      const fleetAdmins = staticusers.filter(user => user.usertype === 'fleetadmin');
      
      const total = fleetAdmins.reduce((sum, fleetAdmin) => {
        return sum + (parseFloat(fleetAdmin.walletBalance) || 0);
      }, 0);
      
      setTotalBalance(total);
      setFleetAdminCount(fleetAdmins.length);
    }
  }, [staticusers, settings]);

  const formatAmount = (value) => {
    const number = parseFloat(value || 0);
    return number.toLocaleString('en-US', {
      minimumFractionDigits: settings?.decimal || 2,
      maximumFractionDigits: settings?.decimal || 2
    });
  };

  return (
    <Grid container spacing={3} style={{ padding: 20 }}>
      <Grid item xs={12}>
        <Card style={{ 
          borderRadius: 20, 
          padding: 40, 
          background: `linear-gradient(135deg, #e67e22 0%, #f39c12 100%)`,
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
        }}>
          <Grid container alignItems="center" spacing={3}>
            <Grid item>
              <AccountBalanceWalletIcon style={{ fontSize: 80, color: colors.WHITE }} />
            </Grid>
            <Grid item xs>
              <Typography variant="h6" style={{ color: colors.WHITE, fontFamily: FONT_FAMILY, marginBottom: 10 }}>
                {t('fleetadmins')} {t('wallet_balance')}
              </Typography>
              <Typography variant="h3" style={{ color: colors.WHITE, fontFamily: FONT_FAMILY, fontWeight: 'bold' }}>
                {settings?.swipe_symbol === false 
                  ? `${settings?.symbol} ${formatAmount(totalBalance)}`
                  : `${formatAmount(totalBalance)} ${settings?.symbol}`
                }
              </Typography>
              <Typography variant="body1" style={{ color: colors.WHITE, fontFamily: FONT_FAMILY, marginTop: 10, opacity: 0.9 }}>
                {t('fleetadmins')}: {fleetAdminCount}
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
}
